function areEqual(prevProps, nextProps) {
  const { value, touched, error, name, disabled } = prevProps;
  const {
    value: nextValue,
    touched: nextTouched,
    error: nextError,
    name: nextName,
    disabled: nextDisabled,
  } = nextProps;

  return (
    value === nextValue &&
    touched === nextTouched &&
    error === nextError &&
    name === nextName &&
    disabled === nextDisabled
  );
}

export default areEqual;
